import WindowScroller from './WindowScroller';

export default WindowScroller;